import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import { useMemo } from 'react';
import type { ColorFilterViewModel } from 'autogen/swagger/all';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import { ActiveCount } from '../shared/styles';

export default function ColorFilterMenuOpener({
    model: {
        displayName,
        options,
        isActive,
        attribute: { id }
    },
    ...restProps
}: {
    model: ColorFilterViewModel;
}) {
    const activeOptions = useMemo(() => options.filter((option) => option.isSelected).length, [options]);
    const filterMenuId = id.toString();
    const { openFilterMenu } = useFilterMenu(filterMenuId);

    return (
        <ButtonWithActiveState size="lg" isActive={isActive} onClick={openFilterMenu} {...restProps}>
            {displayName} {!!activeOptions && <ActiveCount>{activeOptions}</ActiveCount>}
        </ButtonWithActiveState>
    );
}
